/**
 * 区域管理-楼栋号字典
 */
import type { PageContext } from '@zto/zpage'
import { UI_PAGE_EVENTS } from '@zto/zpage-ui-element'
import dayjs from 'dayjs'
import { roomDictDialog } from './_dialogs'
import { SysConfigPaths } from '@/config'


export default {
  body: {
    type: 'crud',
    actions: {
      query: {
        api: '/sys/admin/config/node/list',
        apiParams: {
          parentNodePath: SysConfigPaths.ROOM_DICT,
          status: 1
        },
        method: 'POST',
        // responseTransform: (res: any) => {
        //   if (res?.list) return { data: res.list, total: res.total || 0 }
        //   return res
        // }
      },
      add: {
        label: '添加',
        api: '/sys/admin/config/node/create',
        method: 'POST',
        dialog: roomDictDialog(false),
        successMessage: '添加成功'
      },
      edit: {
        label: '编辑',
        api: '/sys/admin/config/node/update',
        dialog: roomDictDialog(true),
        successMessage: '保存成功'
      },
      delete: {
        label: '删除',
        api: '/sys/admin/config/node/batchDelete',
        method: 'POST',
        payload: { nodeIdList: ['${data.row.nodeId}'] },
        message: '确认删除该户号吗？'
      },
      batchDelete: {
        label: '批量删除',
        api: '/sys/admin/config/node/batchDelete',
        method: 'POST',
        message: '确认批量删除已选户号吗？',
        payload: async ({ app }: PageContext, ext: any) => {
          const { Message } = app.useMessage()
          const selectedRows = ext?.selection
          if (Array.isArray(selectedRows)) {
            // if (!app.getPageSearchData().isCheck) {
            //   Message.warning('请先按供应商进行筛选后再操作推送！')
            //   return false
            // }
            const len = selectedRows?.length
            if (!len) {
              Message.warning('请至少选择一条数据！')
              return false
            }
            const nodeIdList = selectedRows.map((it: any) => it?.nodeId).filter(Boolean)
            return {
              nodeIdList
            }
          }
        }
      }
    },
    searchOn: [UI_PAGE_EVENTS.ACTIVATED],
    search: { hidden: true },
    toolbar: {
      noExport: true,
      items: [{ action: 'add' }, { action: 'batchDelete' }]
    },
    table: {
      showCheckbox: true,
      operation: {
        width: 120,
        items: [{ action: 'edit' }, { action: 'delete' }]
      },
      innerAttrs: {
        operationPosition: 'left',
        noIndex: false,
      },
      columns: [
        // { label: '编号', prop: 'code', minWidth: 80 },
        { label: '户型号', prop: 'name', minWidth: 120 },
        // {
        //   label: '楼栋号通信码',
        //   prop: 'maxFloor',
        //   minWidth: 100,
        //   formatter: (row: any) => {
        //     return row?.data?.tdlNumber || '--'
        //   }
        // },
        {
          label: '添加时间',
          prop: 'gmtCreate',
          minWidth: 160,
          formatter: (row: any) => (row?.gmtCreate ? dayjs(row.gmtCreate).format('YYYY-MM-DD HH:mm:ss') : '--')
        }
      ]
    }
  }
}
